const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const WorkTime = () => import(/* webpackChunkName: "sla" */'@/components/pages/sla/WorkTime');
const Holiday = () => import(/* webpackChunkName: "sla" */'@/components/pages/sla/Holiday');
const Sla = () => import(/* webpackChunkName: "sla" */'@/components/pages/sla/Sla');
const OperateSla = () => import(/* webpackChunkName: "sla" */'@/components/pages/sla/OperateSla');
const TopMenu = () => import(/* webpackChunkName: "base" */'@/components/common/TopMenu');
import store from '@/store';
const routerMapping = {
  'SYS_USER_QUERY': '/system/sla/work-time',
  'SYS_ROLE_QUERY': '/system/sla/holiday',
  'SYS_DEPART_QUERY': '/system/sla/workbench',
}

export default [
  {
    path: 'sla',
    name: 'sla',
    component: TopMenu,
    redirect: () => {
      let index = store.state.tab.workPages.findIndex(p => p.secondParent === '/system/sla');
      if (index > -1) {
        return store.state.tab.workPages[index].routePath;
      } else {
        const roleIds = store.state.base.roleIds;
        let router = '/system/sla/work-time';
        for (var item in routerMapping) {
          if (roleIds.includes(item)) {
            router = routerMapping[item];
            break;
          }
        }
        return router;
      }
    },
    meta: {
      title: 'SLA管理',
      icon: 'sla',
      roles: [
        'SLA_WORK_TIME_QUERY',
        'SLA_HOLIDAY_QUERY',
        'SLA_QUERY'
      ]
    },
    children: [
      {
        path: 'work-time',
        name: 'slaWorkTime',
        meta: {
          title: '工作时间配置',
          roles: ['SLA_WORK_TIME_QUERY'],
          componentName: 'WorkTime',
          activeMenu: '/sla/work-time',
          breadcrumb: [
            {
              name: '工作时间配置',
              path: '/sla/work-time'
            }
          ]
        },
        component: WorkTime
      },
      {
        path: 'holiday',
        name: 'slaHoliday',
        meta: {
          title: '节假日配置',
          roles: ['SLA_HOLIDAY_QUERY'],
          componentName: 'Holiday',
          activeMenu: '/sla/holiday',
          breadcrumb: [
            {
              name: '节假日配置',
              path: '/sla/holiday'
            }
          ]
        },
        component: Holiday
      },
      {
        path: 'workbench',
        name: 'slaWorkbench',
        meta: {
          title: '服务级别配置',
          roles: ['SLA_QUERY'],
          componentName: 'Sla',
          activeMenu: '/sla/workbench',
          breadcrumb: [
            {
              name: '服务级别配置',
              path: '/sla/workbench'
            }
          ]
        },
        component: Sla
      },
      {
        path: 'create-sla',
        name: 'createSla',
        meta: {
          title: '新建服务级别配置',
          hidden: true,
          activeMenu: '/sla/workbench',
          roles: ['SLA_ADD'],
          componentName: 'OperateSla',
          breadcrumb: [
            {
              name: '服务级别配置',
              path: '/sla/workbench'
            },
            {
              name: '新建服务级别配置',
              path: '/sla/create-sla'
            }
          ]
        },
        component: OperateSla
      },
      {
        path: 'edit-sla/:id',
        props: true,
        name: 'editSla',
        meta: {
          title: '编辑服务级别配置',
          hidden: true,
          activeMenu: '/sla/workbench',
          roles: ['SLA_UPDATE'],
          componentName: 'OperateSla',
          breadcrumb: [
            {
              name: '服务级别配置',
              path: '/sla/workbench'
            },
            {
              name: '编辑服务级别配置',
              path: '/sla/edit-sla/:id'
            }
          ]
        },
        component: OperateSla
      }
    ]
  }
];


// WEBPACK FOOTER //
// ./src/router/slaManage.js